import React, { useEffect, useState } from "react";
import styles from "./Viewstudentdetails.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { Modal } from "react-bootstrap";
import Loader from "../../../Loader";
import { AxiosInstance } from "../../../../../axios";
import { ImageUrlPrefix } from "../../../../../labels";

const ViewStudentDetails = () => {
  const navigate = useNavigate();
  const { studentId } = useParams();
  const location = useLocation();
  const {
    INTERVIEWID = null,
    PANELID = null,
    MARKSTATUS = null,
    BATCHID = null,
    ADMISSION_ID = null,
    // Add these filter states
    FILTER_BATCH_NAME = [],
    FILTER_GENDER = [],
    FILTER_MEDIUM = [],
    FILTER_CORE_SUBJECT = [],
    TEAMURL = null,
    FILTER_STUDENT_STATUS = [],
    FILTER_CHIP_DATA = [],
    FCAT = null,
    FCOURSE = null,
    FSTATUS = null,
    FSEARCH = null,
    FDATE = null,
    RESULTSTATUS = 0,
    TYPE,
    PANEL_MARK_STATUS = null,
    PAGE_FROM = null,
    UPDATE_MARK,
    ID,
  } = location.state || {};
  // get user id
  const isResultPublished = Number(UPDATE_MARK) === 1;

  const userJSON = sessionStorage.getItem("userDetails");
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      user_type = user?.user_type;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }

  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  /* ---------------- API CALL ---------------- */
  useEffect(() => {
    fetchStudentDetails();
  }, []);

  const handleClick = () => {
    window.open(TEAMURL, "_blank");
  };
  const fetchStudentDetails = async () => {
    try {
      setIsLoading(true);

      const payload = {
        user_id: studentId || "",
        admission_id: ADMISSION_ID || "",
        type: 5,
      };

      const res = await AxiosInstance.post("/api/modelexam/view", payload);

      if (res?.data?.status) {
        setUserData(res.data.data);
      }
    } catch (error) {
      console.error("View student error", error);
    } finally {
      setIsLoading(false);
    }
  };

  /* ---------------- LOADER ---------------- */
  if (isLoading) {
    return (
      <div className="loaderApi d-flex justify-content-center align-items-center vh-100">
        <Loader />
      </div>
    );
  }

  if (!userData) {
    return <p className="text-center">No data found</p>;
  }

  const eduData = userData?.edu
    ?.filter((e) => e.qualification_type === "EDQ")
    ?.reduce((acc, el) => {
      acc[el.name] = el;
      return acc;
    }, {});

  const techQualData = userData?.edu?.filter(
    (e) => e.qualification_type === "THQ"
  );

  const addressData = userData?.address || [];
  const presentAddress = addressData.find((addr) => addr.address_type === 1);
  const permanentAddress = addressData.find((addr) => addr.address_type === 2);

  const scpCategories = userData?.scp?.filter((cat) => cat)?.join(", ") || "-";

  const handleFileDownload = (filePath) => {
    if (!filePath) return;

    const fileUrl = `${ImageUrlPrefix}${filePath}`;
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const handleBackFilter = () => {
    navigate(`/Viewpanel/${PANELID}`, {
      state: {
        PANELID: PANELID,
        MARKSTATUS: MARKSTATUS,
        BATCHID: BATCHID,
        INTERVIEWID: INTERVIEWID,
        FCAT: FCAT,
        FCOURSE: FCOURSE,
        FSTATUS: FSTATUS,
        FSEARCH: FSEARCH,
        FDATE: FDATE,
        FILTER_BATCH_NAME: FILTER_BATCH_NAME,
        FILTER_GENDER: FILTER_GENDER,
        FILTER_MEDIUM: FILTER_MEDIUM,
        FILTER_CORE_SUBJECT: FILTER_CORE_SUBJECT,
        FILTER_STUDENT_STATUS: FILTER_STUDENT_STATUS,
        FILTER_CHIP_DATA: FILTER_CHIP_DATA,
        TYPE: TYPE,
        PANEL_MARK_STATUS: PANEL_MARK_STATUS,
        PAGE_FROM: PAGE_FROM,
        ID: ID,
      },
    });
  };

  return (
    <div
      className={`${styles.cm_ListViewForm} p-0 container-fluid BathHeader  global_container `}
    >
      <div className="Purchase">
        {/* ================= HEADER ================= */}
        <div className="row align-items-center">
          {/* Title */}
          <div className="col-12 col-md-4 mb-2 mb-md-0">
            <h2 className="TitleHeader">Profile</h2>
          </div>

          {/* Buttons */}
          <div className="col-12 col-md-8 ListBtn d-flex justify-content-md-end justify-content-start">
            <ul className="List-Button d-flex gap-2 mb-0 flex-wrap flex-md-nowrap">
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  onClick={handleBackFilter}
                  className="secondaryButton "
                  variant="primary"
                >
                  Back to View Panel
                </Link>
              </li>

              {user_type !== 2 && (
                <li className="ListBtnItems">
                  <Link
                    to="/ViewInterviewPerfomance"
                    state={{
                      PANELID: PANELID,
                      INTERVIEWID: INTERVIEWID,
                      STUDENTID: studentId,
                    }}
                    className="primaryButton"
                  >
                    View Interview Performance
                  </Link>
                </li>
              )}

              {user_type !== 1 && !isResultPublished && (
                <li className="ListBtnItems">
                  <Link
                    to="/MockInterviewMarksUpdate"
                    state={{
                      studentId,
                      interview_id: INTERVIEWID,
                      panel_id: PANELID,
                      ADMISSION_ID,
                    }}
                    className="primaryButton"
                  >
                    Update Marks
                  </Link>
                </li>
              )}

              {user_type !== 1 && RESULTSTATUS === 0 && (
                <li class="ListBtnItems">
                  <Link
                    to={"#"}
                    onClick={(e) => {
                      if (!TEAMURL) {
                        e.preventDefault(); // stop navigation
                        return;
                      }
                      handleClick(); // optional if you still need it
                    }}
                    className={`primaryButton ${!TEAMURL ? "disabledbtn" : ""}`}
                  >
                    Join
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* ================= BASIC DETAILS ================= */}

        <fieldset className="mt-3" style={{ position: "relative" }}>
          <legend className="w-auto">Basic Details</legend>
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                {[
                  ["First Name", userData.first_name],
                  ["Last Name", userData.last_name],
                  ["Father's Name/Guardian's Name", userData.father_name],
                  ["Mother Name", userData.mother_name],
                  ["Date of Birth", userData.dob?.split("T")[0]],
                  ["Age", userData.age],
                  ["Gender", userData.gender],
                  ["Marital Status", userData.marital_status],
                ].map(([label, value], i) => (
                  <div key={i} className="col-lg-4 col-md-6 my-1">
                    <p className="confirm_label">{label}</p>
                    <p className="confirm_value">{value || "-"}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-12">
              <div className="position-relative text-center">
                {userData?.profile_path ? (
                  <img
                    src={`${ImageUrlPrefix}/${userData.profile_path}`}
                    className={styles.ProfilePhoto}
                    alt="Profile"
                  />
                ) : (
                  <div
                    className={`${styles.ProfilePhoto} d-flex align-items-center justify-content-center bg-opacity-75`}
                  >
                    <img
                      src="/images/default_profile.png"
                      className={styles.ProfilePhoto}
                      alt="Default"
                    />

                    <span id="text">Profile Picture</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </fieldset>

        {/* ================= ID PROOF ================= */}
        <div className="row mt-3">
          {/* Widget 1 – ID Proof */}
          <div className="col-md-6">
            <fieldset>
              <legend className="w-auto">ID Proof</legend>

              <div className="row">
                <div className="col-6">
                  <p className="confirm_label">Aadhar Number</p>
                  <p className="confirm_value">{userData?.aadhar_no || "-"}</p>
                </div>

                <div className="col-6">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center gap-1">
                      <p className="confirm_label m-0 p-0">
                        Uploaded AADHAR Card
                      </p>
                      {userData?.aadhar_path && (
                        <span
                          className="material-icons align-middle download_icon"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            window.open(
                              `${ImageUrlPrefix}/${userData.aadhar_path}`,
                              "_blank"
                            )
                          }
                        >
                          file_download
                        </span>
                      )}
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {userData?.original_aadhar_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          {/* Widget 2 – Communal Reservation */}
          <div className="col-md-6">
            <fieldset>
              <legend className="w-auto">Communal Reservation Category</legend>

              <div className="row">
                <div className="col-6">
                  <p className="confirm_label">Category</p>
                  <p className="confirm_value">{userData?.community || "-"}</p>
                </div>

                <div className="col-6">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center gap-1">
                      <p className="confirm_label m-0 p-0">
                        Uploaded Certificate
                      </p>

                      {userData?.original_caste_path && (
                        <span
                          className="material-icons align-middle download_icon"
                          style={{ cursor: "pointer" }}
                          // onClick={() =>
                          //   handleFileDownload(userData.original_caste_path)
                          // }
                          onClick={() =>
                            window.open(
                              `${ImageUrlPrefix}/${userData.community_path}`,
                              "_blank"
                            )
                          }
                        >
                          file_download
                        </span>
                      )}
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {userData?.original_caste_path || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        {/* =================Place of Birth ================= */}
        <div className="row mt-3">
          <div className="col-md-12">
            <fieldset>
              <legend className="w-auto">Place of Birth</legend>

              <div className="row">
                <div className="col-6">
                  <p className="confirm_label">Place of Birth</p>
                  <p className="confirm_value">
                    {userData?.Courses.place_birth || "-"}
                  </p>
                </div>

                <div className="col-6">
                  <p className="confirm_label">District</p>
                  <p className="confirm_value">
                    {userData?.Courses.district_name || "-"}
                  </p>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        {/* ================= Special Category ================= */}
        <div className="row mt-3">
          <div className="col-md-12">
            <fieldset>
              <legend className="w-auto">Special Category</legend>

              <div className="row">
                <div className="col-12">
                  <p className="confirm_label">Category</p>
                  <p className="confirm_value">{scpCategories}</p>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        {/* ================= Address ================= */}
        <div className="row mt-3">
          {/* Present Address */}
          <div className="col-md-6">
            <fieldset>
              <legend className="w-auto">Present Address</legend>

              <p className="confirm_label">Present Address</p>
              <p className="confirm_value">
                {presentAddress ? (
                  <>
                    {presentAddress.address1 && `${presentAddress.address1}, `}
                    {presentAddress.address2 && `${presentAddress.address2}, `}
                    <br />
                    {presentAddress.address3 && `${presentAddress.address3}, `}
                    {presentAddress.landmark && `${presentAddress.landmark}`}
                    <br />
                    {presentAddress.taluk && `${presentAddress.taluk} Taluk, `}
                    {presentAddress.district_name &&
                      `${presentAddress.district_name}, `}
                    <br />
                    {presentAddress.state_name &&
                      `${presentAddress.state_name} - `}
                    {presentAddress.postal_code || ""}
                  </>
                ) : (
                  "_"
                )}
              </p>
            </fieldset>
          </div>

          {/* Permanent Address */}
          <div className="col-md-6">
            <fieldset>
              <legend className="w-auto">Permanent Address</legend>

              <p className="confirm_label">Permanent Address</p>
              <p className="confirm_value">
                {permanentAddress ? (
                  <>
                    {permanentAddress.address1 &&
                      `${permanentAddress.address1}, `}
                    {permanentAddress.address2 &&
                      `${permanentAddress.address2}, `}
                    <br />
                    {permanentAddress.address3 &&
                      `${permanentAddress.address3}, `}
                    {permanentAddress.landmark &&
                      `${permanentAddress.landmark}`}
                    <br />
                    {permanentAddress.taluk &&
                      `${permanentAddress.taluk} Taluk, `}
                    {permanentAddress.district_name &&
                      `${permanentAddress.district_name}, `}
                    <br />
                    {permanentAddress.state_name &&
                      `${permanentAddress.state_name} - `}
                    {permanentAddress.postal_code || ""}
                  </>
                ) : (
                  "_"
                )}
              </p>
            </fieldset>
          </div>
        </div>

        {/* ================= SSLC + HSC ================= */}
        <div className="row mt-3">
          {/* SSLC */}
          {eduData?.sslc && (
            <div className="col-md-6">
              <fieldset>
                <legend className="w-auto">SSLC</legend>
                <div className="row">
                  <div className="col-6">
                    <p className="confirm_label">Certificate Number</p>
                    <p className="confirm_value">
                      {eduData.sslc.certificate_no || "-"}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="confirm_label">Year of Passing</p>
                    <p className="confirm_value">
                      {eduData.sslc.year_of_passing || "-"}
                    </p>
                  </div>
                  <div className="col-6 mt-2">
                    <p className="confirm_label">Marks Percentage</p>
                    <p className="confirm_value">
                      {eduData.sslc.marks_percentage || "-"}
                    </p>
                  </div>
                  <div className="col-6 mt-2">
                    <p className="confirm_label">Education Board</p>
                    <p className="confirm_value">
                      {eduData.sslc.edu_board || "-"}
                    </p>
                  </div>
                  <div className="col-6 mt-2">
                    <p className="confirm_label">Medium of Instruction</p>
                    <p className="confirm_value">
                      {eduData.sslc.edu_medium || "-"}
                    </p>
                  </div>
                  <div className="col-6 mt-2">
                    <p className="confirm_label">School Name</p>
                    <p className="confirm_value">
                      {eduData.sslc.institute || "-"}
                    </p>
                  </div>

                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <p className="confirm_label m-0 p-0">
                          Uploaded Certificate
                        </p>

                        {eduData?.sslc?.certificate_path && (
                          <span
                            className="material-icons align-middle download_icon"
                            style={{ cursor: "pointer" }}
                            // onClick={() =>
                            //   handleFileDownload(eduData.sslc.certificate_path)
                            // }
                            onClick={() =>
                              window.open(
                                `${ImageUrlPrefix}/${eduData?.sslc?.certificate_path}`,
                                "_blank"
                              )
                            }
                          >
                            file_download
                          </span>
                        )}
                      </div>

                      <p className="confirm_value my-1 m-0 p-0">
                        {eduData?.sslc?.original_file_path || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          )}

          {/* HSC */}
          {eduData?.hsc && (
            <div className="col-md-6">
              <fieldset>
                <legend className="w-auto">HSC</legend>
                <div className="row">
                  <div className="col-6">
                    <p className="confirm_label">Certificate Number</p>
                    <p className="confirm_value">
                      {eduData.hsc.certificate_no || "-"}
                    </p>
                  </div>

                  <div className="col-6">
                    <p className="confirm_label">Year of Passing</p>
                    <p className="confirm_value">
                      {eduData.hsc.year_of_passing || "-"}
                    </p>
                  </div>

                  <div className="col-6 mt-2">
                    <p className="confirm_label">Marks Percentage</p>
                    <p className="confirm_value">
                      {eduData.hsc.marks_percentage || "-"}
                    </p>
                  </div>

                  <div className="col-6 mt-2">
                    <p className="confirm_label">Education Board</p>
                    <p className="confirm_value">
                      {eduData.hsc.edu_board || "-"}
                    </p>
                  </div>

                  <div className="col-6 mt-2">
                    <p className="confirm_label">Medium of Instruction</p>
                    <p className="confirm_value">
                      {eduData.hsc.edu_medium || "-"}
                    </p>
                  </div>

                  <div className="col-6 mt-2">
                    <p className="confirm_label">School Name</p>
                    <p className="confirm_value">
                      {eduData.hsc.institute || "-"}
                    </p>
                  </div>

                  {eduData?.hsc?.certificate_path && (
                    <div className="my-1 col-lg-3 col-md-3 col-12">
                      <div className="d-flex flex-column">
                        <div className="d-flex align-items-center">
                          <p className="confirm_label m-0 p-0">
                            Uploaded Certificate
                          </p>

                          <span
                            className="material-icons align-middle download_icon"
                            style={{ cursor: "pointer" }}
                            // onClick={() =>
                            //   handleFileDownload(eduData.hsc.certificate_path)
                            // }
                            onClick={() =>
                              window.open(
                                `${ImageUrlPrefix}/${eduData.hsc.certificate_path}`,
                                "_blank"
                              )
                            }
                          >
                            file_download
                          </span>
                        </div>

                        <p className="confirm_value my-1 m-0 p-0">
                          {eduData.hsc.original_file_path || "-"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </fieldset>
            </div>
          )}
        </div>

        {/* ================= UG ================= */}
        {eduData?.UG && (
          <fieldset className="mt-3">
            <legend className="w-auto">UG</legend>

            <div className="row">
              <div className="col-md-3">
                <p className="confirm_label">Certificate Number</p>
                <p className="confirm_value">
                  {eduData.UG.certificate_no || "-"}
                </p>
              </div>

              <div className="col-md-3">
                <p className="confirm_label">Year of Passing</p>
                <p className="confirm_value">
                  {eduData.UG.year_of_passing || "-"}
                </p>
              </div>

              <div className="col-md-3">
                <p className="confirm_label">Degree</p>
                <p className="confirm_value">{eduData.UG.degree_name || "-"}</p>
              </div>

              <div className="col-md-3">
                <p className="confirm_label">Major</p>
                <p className="confirm_value">
                  {eduData.UG.type_of_degree === 1
                    ? "Others"
                    : eduData.UG.major_subject || "-"}
                </p>
              </div>

              <div className="col-md-3 mt-2">
                <p className="confirm_label">Marks Percentage</p>
                <p className="confirm_value">
                  {eduData.UG.marks_percentage || "-"}
                </p>
              </div>

              <div className="col-md-3 mt-2">
                <p className="confirm_label">Class</p>
                <p className="confirm_value">{eduData.UG.grade || "-"}</p>
              </div>

              <div className="col-md-3 mt-2">
                <p className="confirm_label">Name of the Institute</p>
                <p className="confirm_value">{eduData.UG.institute || "-"}</p>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <p className="confirm_label m-0 p-0">
                      Uploaded Certificate
                    </p>

                    {eduData?.UG?.certificate_path && (
                      <span
                        className="material-icons align-middle download_icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   handleFileDownload(eduData.UG.certificate_path)
                        // }
                        onClick={() =>
                          window.open(
                            `${ImageUrlPrefix}/${eduData.UG.certificate_path}`,
                            "_blank"
                          )
                        }
                      >
                        file_download
                      </span>
                    )}
                  </div>

                  <p className="confirm_value my-1 m-0 p-0">
                    {eduData?.UG?.original_file_path || "-"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {/* ================= PG ================= */}
        {eduData?.PG && (
          <fieldset className="mt-3">
            <legend className="w-auto">PG</legend>
            <div className="row">
              <div className="col-md-3">
                <p className="confirm_label">Certificate Number</p>
                <p className="confirm_value">
                  {eduData.PG.certificate_no || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Year of Passing</p>
                <p className="confirm_value">
                  {eduData.PG.year_of_passing || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Degree</p>
                <p className="confirm_value">{eduData.PG.degree_name || "-"}</p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Major</p>
                <p className="confirm_value">
                  {eduData.PG.type_of_degree === 1
                    ? "Others"
                    : eduData.PG.major_subject || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Marks Percentage</p>
                <p className="confirm_value">
                  {eduData.PG.marks_percentage || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Class</p>
                <p className="confirm_value">{eduData.PG.grade || "-"}</p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Institute</p>
                <p className="confirm_value">{eduData.PG.institute || "-"}</p>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <p className="confirm_label m-0 p-0">
                      Uploaded Certificate
                    </p>
                    {eduData?.PG?.certificate_path && (
                      <span
                        className="material-icons align-middle download_icon"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          window.open(
                            `${ImageUrlPrefix}/${eduData.PG.certificate_path}`,
                            "_blank"
                          )
                        }
                      >
                        file_download
                      </span>
                    )}
                  </div>
                  <p className="confirm_value my-1 m-0 p-0">
                    {eduData?.PG?.original_file_path || "-"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {/* ================= DIPLOMA ================= */}
        {eduData?.Diploma && (
          <fieldset className="mt-3">
            <legend className="w-auto">Diploma</legend>
            <div className="row">
              <div className="col-md-3">
                <p className="confirm_label">Certificate Number</p>
                <p className="confirm_value">
                  {eduData.Diploma.certificate_no || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Year of Passing</p>
                <p className="confirm_value">
                  {eduData.Diploma.year_of_passing || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Degree</p>
                <p className="confirm_value">
                  {eduData.Diploma.degree_name || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Major</p>
                <p className="confirm_value">
                  {eduData.Diploma.type_of_degree === 1
                    ? "Others"
                    : eduData.Diploma.major_subject || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Marks Percentage</p>
                <p className="confirm_value">
                  {eduData.Diploma.marks_percentage || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Class</p>
                <p className="confirm_value">{eduData.Diploma.grade || "-"}</p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Institute</p>
                <p className="confirm_value">
                  {eduData.Diploma.institute || "-"}
                </p>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <p className="confirm_label m-0 p-0">
                      Uploaded Certificate
                    </p>

                    {eduData?.Diploma?.certificate_path && (
                      <span
                        className="material-icons align-middle download_icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   handleFileDownload(eduData.Diploma.certificate_path)
                        // }
                        onClick={() =>
                          window.open(
                            `${ImageUrlPrefix}/${eduData.Diploma.certificate_path}`,
                            "_blank"
                          )
                        }
                      >
                        file_download
                      </span>
                    )}
                  </div>

                  <p className="confirm_value my-1 m-0 p-0">
                    {eduData?.Diploma?.original_file_path || "-"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {/* ================= Professional Courses ================= */}
        {eduData?.["Professional Courses"] && (
          <fieldset className="mt-3">
            <legend className="w-auto">Professional Courses</legend>
            <div className="row">
              <div className="col-md-3">
                <p className="confirm_label">Certificate Number</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].certificate_no || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Year of Passing</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].year_of_passing || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Degree</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].degree_name || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Major</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].type_of_degree === 1
                    ? "Others"
                    : eduData["Professional Courses"].major_subject || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Marks Percentage</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].marks_percentage || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Class</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].grade || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Institute</p>
                <p className="confirm_value">
                  {eduData["Professional Courses"].institute || "-"}
                </p>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <p className="confirm_label m-0 p-0">
                      Uploaded Certificate
                    </p>

                    {eduData?.["Professional Courses"]?.certificate_path && (
                      <span
                        className="material-icons align-middle download_icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   handleFileDownload(
                        //     eduData["Professional Courses"].certificate_path
                        //   )
                        // }
                        onClick={() =>
                          window.open(
                            `${ImageUrlPrefix}/${eduData["Professional Courses"].certificate_path}`,
                            "_blank"
                          )
                        }
                      >
                        file_download
                      </span>
                    )}
                  </div>

                  <p className="confirm_value my-1 m-0 p-0">
                    {eduData?.["Professional Courses"]?.original_file_path ||
                      "-"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {/* ================= Integrated PG ================= */}
        {eduData?.["Integrated PG"] && (
          <fieldset className="mt-3">
            <legend className="w-auto">Integrated PG</legend>
            <div className="row">
              <div className="col-md-3">
                <p className="confirm_label">Certificate Number</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].certificate_no || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Year of Passing</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].year_of_passing || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Degree</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].degree_name || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Major</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].type_of_degree === 1
                    ? "Others"
                    : eduData["Integrated PG"].major_subject || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Marks Percentage</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].marks_percentage || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Class</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].grade || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Institute</p>
                <p className="confirm_value">
                  {eduData["Integrated PG"].institute || "-"}
                </p>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <p className="confirm_label m-0 p-0">
                      Uploaded Certificate
                    </p>

                    {eduData?.["Integrated PG"]?.certificate_path && (
                      <span
                        className="material-icons align-middle download_icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   handleFileDownload(
                        //     eduData["Integrated PG"].certificate_path
                        //   )
                        // }
                        onClick={() =>
                          window.open(
                            `${ImageUrlPrefix}/${eduData["Integrated PG"].certificate_path}`,
                            "_blank"
                          )
                        }
                      >
                        file_download
                      </span>
                    )}
                  </div>

                  <p className="confirm_value my-1 m-0 p-0">
                    {eduData?.["Integrated PG"]?.original_file_path || "-"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {/* ================= Others ================= */}
        {eduData?.Others && (
          <fieldset className="mt-3">
            <legend className="w-auto">Others</legend>
            <div className="row">
              <div className="col-md-3">
                <p className="confirm_label">Certificate Number</p>
                <p className="confirm_value">
                  {eduData.Others.certificate_no || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Year of Passing</p>
                <p className="confirm_value">
                  {eduData.Others.year_of_passing || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Degree</p>
                <p className="confirm_value">
                  {eduData.Others.degree_name || "-"}
                </p>
              </div>
              <div className="col-md-3">
                <p className="confirm_label">Major</p>
                <p className="confirm_value">
                  {eduData.Others.type_of_degree === 1
                    ? "Others"
                    : eduData.Others.major_subject || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Marks Percentage</p>
                <p className="confirm_value">
                  {eduData.Others.marks_percentage || "-"}
                </p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Class</p>
                <p className="confirm_value">{eduData.Others.grade || "-"}</p>
              </div>
              <div className="col-md-3 mt-2">
                <p className="confirm_label">Institute</p>
                <p className="confirm_value">
                  {eduData.Others.institute || "-"}
                </p>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center">
                    <p className="confirm_label m-0 p-0">
                      Uploaded Certificate
                    </p>

                    {eduData?.Others?.certificate_path && (
                      <span
                        className="material-icons align-middle download_icon"
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   handleFileDownload(eduData.Others.certificate_path)
                        // }
                        onClick={() =>
                          window.open(
                            `${ImageUrlPrefix}/${eduData.Others.certificate_path}`,
                            "_blank"
                          )
                        }
                      >
                        file_download
                      </span>
                    )}
                  </div>

                  <p className="confirm_value my-1 m-0 p-0">
                    {eduData?.Others?.original_file_path || "-"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        {/* Technical Qualification */}
        {techQualData && techQualData.length > 0 && (
          <fieldset className="mt-3">
            <legend className="w-auto">Technical Qualification</legend>

            {techQualData.map((tech, idx) => (
              <div key={idx} className="row mb-3">
                <div className="col-md-3">
                  <p className="confirm_label">Technical Course</p>
                  <p className="confirm_value">{tech.name || "-"}</p>
                </div>

                <div className="col-md-3">
                  <p className="confirm_label">Level</p>
                  <p className="confirm_value">{tech.level || "-"}</p>
                </div>

                <div className="col-md-3">
                  <p className="confirm_label">Language/Medium</p>
                  <p className="confirm_value">{tech.edu_medium || "-"}</p>
                </div>

                <div className="col-md-3">
                  <p className="confirm_label">Certificate Number</p>
                  <p className="confirm_value">{tech.certificate_no || "-"}</p>
                </div>

                <div className="col-md-3 mt-2">
                  <p className="confirm_label">Grade</p>
                  <p className="confirm_value">{tech.grade || "-"}</p>
                </div>

                <div className="col-md-3 mt-2">
                  <p className="confirm_label">Year of Passing</p>
                  <p className="confirm_value">{tech.year_of_passing || "-"}</p>
                </div>

                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center">
                      <p className="confirm_label m-0 p-0">
                        Uploaded Certificate
                      </p>

                      {tech?.certificate_path && (
                        <span
                          className="material-icons align-middle download_icon"
                          style={{ cursor: "pointer" }}
                          // onClick={() =>
                          //   handleFileDownload(tech.certificate_path)
                          // }
                          onClick={() =>
                            window.open(
                              `${ImageUrlPrefix}/${userData.tech.certificate_path}`,
                              "_blank"
                            )
                          }
                        >
                          file_download
                        </span>
                      )}
                    </div>

                    <p className="confirm_value my-1 m-0 p-0">
                      {tech?.original_file_path
                        ? tech.original_file_path.split("/").pop()
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </fieldset>
        )}

        {/* Other Relevant Information */}
        <fieldset className="mt-3">
          <legend className="w-auto">Other Relevant Information</legend>

          <div className="row">
            <div className="col-md-3">
              <p className="confirm_label">
                Have You Already Studied for Competitive Examination?
              </p>
              <p className="confirm_value">
                {userData.Courses?.competitive_exam === 1 ? "Yes" : "No"}
              </p>
            </div>

            <div className="col-md-3">
              <p className="confirm_label">Name of the Examination</p>
              <p className="confirm_value">
                {userData.Courses?.competitive_exam_name || "-"}
              </p>
            </div>

            <div className="col-md-3">
              <p className="confirm_label">
                Name of the Institute you studied before (separated by commas)
              </p>
              <p className="confirm_value">
                {userData.Courses?.institute_name || "-"}
              </p>
            </div>

            <div className="col-md-3">
              <p className="confirm_label">
                Have You Cleared Any Exam Previously?
              </p>
              <p className="confirm_value">
                {userData.Courses?.cleared_any_exam > 0 ? "Yes" : "No"}
              </p>
            </div>

            <div className="col-md-3 mt-2">
              <p className="confirm_label">
                How many exams have you cleared in the past?
              </p>
              <p className="confirm_value">
                {userData.Courses?.cleared_any_exam || "-"}
              </p>
            </div>

            <div className="col-md-3 mt-2">
              <p className="confirm_label">Exam details</p>
              <p className="confirm_value">
                {userData.Courses?.exam_details || "-"}
              </p>
            </div>

            <div className="col-md-3 mt-2">
              <p className="confirm_label">Are you a government employee?</p>
              <p className="confirm_value">
                {userData.Courses?.govt_emp === 1 ? "Yes" : "No"}
              </p>
            </div>

            <div className="col-md-3 mt-2">
              <p className="confirm_label">Designation</p>
              <p className="confirm_value">
                {userData.Courses?.designation || "-"}
              </p>
            </div>

            <div className="col-md-3 mt-2">
              <p className="confirm_label">Department</p>
              <p className="confirm_value">
                {userData.Courses?.department || "-"}
              </p>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default ViewStudentDetails;
